
import {QueryCommand} from "xmgoing-server";
import {delFileById} from "@/components/fileCtl/api/file";
import {unref} from "vue";
import {ViewModel} from "@/main-page/jsParseEngine/ViewModel";
import {usePageModelsStore} from "@/store/modules/pageModels";
export function useFileOperation(emits,flushFileList=()=>{},imgUrl='',fileList){
  /**
   * 文件下载
   */
  const openFile = function (id: string, name: string) {
    const queryCommand = new QueryCommand({showTip:false,url:`/api/pe-attachment/oss/fileInfo`,method:"GET"});
    queryCommand.executeQueryPromise({params:{fileId: id}}).then((res)=>{
      if(res&&res[0]){
        const {downloadUrl}:any=res[0];
        if(downloadUrl){
          window.open(downloadUrl);
        }
      }
    })
  };

  const pageModelsStore: any = usePageModelsStore();
  /**
   * 文件下载
   */
  const downFile = function (fileItem) {
    let downloadFileNameUrl = "";
    if(fileItem.downloadFileName){
      if(fileItem.downloadFileName.indexOf("vuex.state.") > -1){
        const viewModel = new ViewModel({pageModelsStore});
        const fileNameVuex = fileItem.downloadFileName.split(".")[2];
        downloadFileNameUrl = "?filename=" + viewModel.getVuexParams(fileNameVuex);
      }else{
        downloadFileNameUrl = "?filename=" + fileItem.downloadFileName;
      }
    }
    // const viewModel = new ViewModel({pageModelsStore});
    // downloadFileNameUrl = viewModel.getVuexParams("tempdownloadFileName")

    // emits('loading',{});
    // const queryCommand = new QueryCommand({});
    // queryCommand.executeExport(
    //   `/api/pe-attachment/attachment/download/` + fileItem.id + downloadFileNameUrl,
    //   fileItem.fileName,
    //   {}
    // );

    openFile(fileItem.id, fileItem.downloadFileName)
  };

  const isImgFile=function (fileItem){
    const filePath=fileItem.filePath||fileItem.name;
    const imgMap=['JPG','JPEG','PNG','GIF','ICO'];
    if(filePath){
      const filePathAry=(filePath+'').split(".");
      if(imgMap.includes((filePathAry[filePathAry.length-1]+'').toUpperCase())){
        return  true;
      }
    }
    return false;
  }

  const getFileTypeIcon=function (fileItem){
    const filePath=fileItem.filePath||fileItem.name;
    const filePathAry=(filePath+'').split(".");
    return 'file-'+filePathAry[filePathAry.length-1];
  }

  /**
   * 删除附件操作
   * @param fileItem
   */
  const removeFile =async function (fileItem) {
    // 获取文件ID，优先使用 fileItem.id，如果没有则尝试从 response 中获取
    const fileId = fileItem.id || (fileItem.response && fileItem.response.data && fileItem.response.data[0] && fileItem.response.data[0].id);
    if(fileId){
      emits('loading',{});
      await delFileById(fileId);
      emits('flushFileList',{})
      emits('closeLoading',{});
      flushFileList&&flushFileList();
    }
    if(unref(imgUrl)){
      emits('update:imgUrl', ``);
      if(fileList){
        nextTick(()=>{
          fileList.value=[];
        })
      }
      return;
    }
  };

  return {
    removeFile,
    getFileTypeIcon,
    isImgFile,
    downFile
  }
}
